import { render, staticRenderFns } from "./UpgradeButton.vue?vue&type=template&id=fe185d5c&"
import script from "./UpgradeButton.vue?vue&type=script&lang=js&"
export * from "./UpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe185d5c')) {
      api.createRecord('fe185d5c', component.options)
    } else {
      api.reload('fe185d5c', component.options)
    }
    module.hot.accept("./UpgradeButton.vue?vue&type=template&id=fe185d5c&", function () {
      api.rerender('fe185d5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/UpgradeButton.vue"
export default component.exports